import secOpsLogo from "../../templates/partials/_logo-secops-threat.html";
import enterpriseLogo from "../../templates/partials/_logo-enterprise.html";

function setLogo() {
  if (!globalThis.isPrivate) {
    return;
  }
  let el = document.querySelector(".main-nav__logo-holder");
  if (!el) {
    return;
  }
  if (location.host === "sandbox.recordedfuture.com" || location.host === "localhost:9012") {
    el.innerHTML = secOpsLogo;
  } else if (location.host === "private.tria.ge" || location.host === "us-sandbox.recordedfuture.com") {
    el.innerHTML = enterpriseLogo;
  }
}

setLogo();
